import { FinanceIntervalTypes } from '../../../../common/ui/confirmFinances/confirmFinances.constants';

import _ from 'lodash';

const standingOrdersFormDefinition = [
  {
    name: 'name',
    type: 'text',
    required: true,
  },
  {
    name: 'iban',
    readonly: true,
    type: 'text',
    required: true,
    options: {
      validate: 'iban',
    },
  },
  {
    name: 'bankCode',
    readonly: true,
    type: 'text',
    options: {
      validate: 'bic',
    },
  },
  {
    name: 'amount',
    type: 'text',
    required: true,
  },
  {
    name: 'currency',
    readonly: true,
    type: 'text',
  },
  {
    name: 'interval',
    type: 'select',
    typeOptions: {
      modelKey: 'key',
      selectables: FinanceIntervalTypes,
    },
    required: true,
  },
  {
    name: 'executionDay',
    readonly: true,
    type: 'text',
  },
  {
    name: 'nextExecution',
    type: 'date',
    required: true,
  },
  {
    name: 'lastExecution',
    type: 'date',
  },
  {
    name: 'purpose',
    type: 'textarea',
  },
];

const appointmentTransfersFormDefinition = [
  {
    name: 'name',
    type: 'text',
    required: true,
    readonly: true,
  },
  {
    name: 'iban',
    type: 'text',
    required: true,
    options: {
      validate: 'iban',
    },
    readonly: true,
  },
  {
    name: 'bankCode',
    type: 'text',
    options: {
      validate: 'bic',
    },
    readonly: true,
  },
  {
    name: 'amount',
    type: 'text',
    required: true,
    readonly: true,
  },
  {
    name: 'currency',
    type: 'text',
    readonly: true,
  },
  {
    name: 'executionDay',
    readonly: true,
    type: 'text',
  },
  {
    name: 'nextExecution',
    label: 'executionDate',
    type: 'date',
    required: true,
    readonly: true,
  },
  {
    name: 'purpose',
    type: 'textarea',
    readonly: true,
  },
];

const insertArrayAt = (array, index, values) => {
  return _.concat(_.slice(array, 0, index), values, _.slice(array, index));
};

export const StandingOrderFormFields = (
  type,
  featureAutoApplyStandingOrders,
) => {
  if (type === 'scheduled') {
    return appointmentTransfersFormDefinition;
  }

  let fields = standingOrdersFormDefinition;

  if (type === 'debit' && featureAutoApplyStandingOrders) {
    fields = insertArrayAt(fields, 5, [
      {
        name: 'mref',
        type: 'text',
        required: true,
      },
      {
        name: 'creditorId',
        type: 'text',
        required: true,
        options: {
          validate: 'cid',
        },
      },
      {
        name: 'mandateSignatureDate',
        type: 'date',
        required: true,
      },
    ]);
  }
  return fields;
};
